import { isAxiosError } from 'axios';
import { Navigate } from 'react-router';

import { useTranslate } from '@i18n';
import { useActivitySwings, useReadOnlyCurrentActivity } from '@queries';
import { ErrorScreen, LoadingScreen } from '@screens';

import { LINKS } from '../utils/routes';
import * as PARAMETERS from '../utils/routes/parameters';

export const CurrentActivityScreen = () => {
    const { data: currentActivity, error, isError, isPending } = useReadOnlyCurrentActivity();
    const t = useTranslate();
    const activityId = currentActivity?.id ?? -1;
    const activitySwings = useActivitySwings(activityId);

    const isMissingActivity = (isAxiosError(error) && error.response?.status === 404) || (!isError && !currentActivity);
    const isMissingLayout =
        (isAxiosError(error) && error.response?.status === 404) || (!isError && !currentActivity?.layoutId);
    const isMissingClub =
        (isAxiosError(error) && error.response?.status === 404) || (!isError && !currentActivity?.club);

    if (isPending || (currentActivity && activitySwings.isLoading)) {
        return <LoadingScreen message={t('loaders.current_activity')} />;
    }

    if (isMissingActivity || isMissingLayout || isMissingClub) {
        return <Navigate to={PARAMETERS.NEW_ACTIVITY} replace />;
    }

    if (isError || activitySwings.isError) {
        return <ErrorScreen message={t('error_message.no_data_available')} />;
    }

    const firstSwing = activitySwings.data?.[0];
    const destination = firstSwing ? LINKS.getFullActivity(activityId, firstSwing.uuid) : LINKS.getActivity(activityId);

    return <Navigate to={destination} replace />;
};
